module.exports = __webpack_public_path__ + "img/H01116-74.957548e1.jpg";